import { ReactElement } from "react";
import { useRenderManager } from "../../useRenderManager";
import { HowToLiveTileContent } from "./HowToLiveTileContent";
import { HowToLiveInformationProvider } from "./provider";
import { AppType } from "client/Api/Apps/common";
import { TileRenderState } from "../../RenderState/common";
import { TileContextProvider } from "../../TileContextProvider";
import { Coordinate } from "client/Misc/commonTypes";

export type HowToTileContentProps = {
	renderState: TileRenderState<AppType.HowTo>;
	provider: HowToLiveInformationProvider;
	onOpenTileMenu: (coordinate: Coordinate) => void;
};

export const HowToTileContent = (props: HowToTileContentProps): ReactElement => {
	const {
		renderState,
		provider,
		onOpenTileMenu
	} = props;

	const { dimension } = renderState;

	const tileContent: ReactElement = useRenderManager(
		dimension,
		() => (
			<HowToLiveTileContent
				provider={provider}
				onOpenTileMenu={onOpenTileMenu}
			/>
		)
	);

	return (
		<TileContextProvider
			renderState={renderState}
		>
			{tileContent}
		</TileContextProvider>
	);
};
HowToTileContent.displayName = "HowToTileContent";
